import validate from "/opt/build/repo/node_modules/.pnpm/nuxt@3.17.7_patch_hash=c6f354dff9a1b37e0e83493471843b5381f29a5a6b3b3e7486ab1a8be4de2ac4_ec29dcd8f4a7956f686a83b6f6500340/node_modules/nuxt/dist/pages/runtime/validate.js";
import header_45global from "/opt/build/repo/domains/core/middleware/header.global.ts";
import i18n_45global from "/opt/build/repo/domains/core/middleware/i18n.global.ts";
import optimizely_45scroll_45global from "/opt/build/repo/domains/core/middleware/optimizelyScroll.global.ts";
import _15_45to_45canvas_45url_45global from "/opt/build/repo/domains/commerce/middleware/15ToCanvasUrl.global.ts";
import auto_45promo_45code_45global from "/opt/build/repo/domains/commerce/middleware/autoPromoCode.global.ts";
import dialogs_45global from "/opt/build/repo/domains/commerce/middleware/dialogs.global.ts";
import seo_45meta_45global from "/opt/build/repo/domains/commerce/middleware/seoMeta.global.ts";
import preserve_45query_45global from "/opt/build/repo/domains/content/middleware/preserveQuery.global.ts";
import manifest_45route_45rule from "/opt/build/repo/node_modules/.pnpm/nuxt@3.17.7_patch_hash=c6f354dff9a1b37e0e83493471843b5381f29a5a6b3b3e7486ab1a8be4de2ac4_ec29dcd8f4a7956f686a83b6f6500340/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  header_45global,
  i18n_45global,
  optimizely_45scroll_45global,
  _15_45to_45canvas_45url_45global,
  auto_45promo_45code_45global,
  dialogs_45global,
  seo_45meta_45global,
  preserve_45query_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "plp-store-filter": () => import("/opt/build/repo/domains/commerce/middleware/plpStoreFilter.ts")
}